// Funcionalidades tabs (product landings).
//
// Vertical tab list + big visual panel. Click switches; the section also
// auto-advances: the active tab shows a progress bar (CSS animation whose
// duration comes from data-ftabs-interval) and moves on when it completes.
// Hovering/focusing the component or scrolling it off-viewport pauses the bar
// (animation-play-state), so the cycle resumes where it left off. Under
// prefers-reduced-motion the bar never animates, so auto-advance simply never
// fires — click still switches. No scroll hijacking.

function initFTabs(root) {
  const tabs    = Array.from(root.querySelectorAll('[data-ftab]'));
  const items   = tabs.map((t) => t.closest('.ftabs__item'));
  const visuals = Array.from(root.querySelectorAll('[data-fvisual]'));
  if (tabs.length < 2) return;

  const interval = parseInt(root.getAttribute('data-ftabs-interval'), 10) || 5000;
  root.style.setProperty('--ftabs-dur', `${interval}ms`);

  let current = -1;

  function setActive(i) {
    if (i === current) return;
    current = i;
    tabs.forEach((t, idx) => {
      const on = idx === i;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      items[idx].classList.toggle('is-active', on);
    });
    visuals.forEach((v, idx) => v.classList.toggle('is-active', idx === i));
  }

  tabs.forEach((t, i) => t.addEventListener('click', () => setActive(i)));

  // Advance when the active tab's progress bar finishes filling.
  root.addEventListener('animationend', (e) => {
    if (!e.target.matches('.ftabs__item.is-active .ftabs__progress i')) return;
    setActive((current + 1) % tabs.length);
  });

  // Pause while the user is on/inside the component…
  ['pointerenter', 'focusin'].forEach((ev) => {
    root.addEventListener(ev, () => root.classList.add('is-paused'));
  });
  ['pointerleave', 'focusout'].forEach((ev) => {
    root.addEventListener(ev, () => root.classList.remove('is-paused'));
  });

  // …and while the section is out of view.
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      root.classList.toggle('is-offscreen', !entry.isIntersecting);
    }, { threshold: 0.25 });
    io.observe(root);
  }

  setActive(0);
}

function initFTabsAll() {
  document.querySelectorAll('[data-ftabs]').forEach(initFTabs);
}

if (document.readyState !== 'loading') initFTabsAll();
else document.addEventListener('DOMContentLoaded', initFTabsAll);
